<template>
    <div class="ayuda-container" data-app>
        <div class="doc-section ayuda-scope">
            <div class="container-fluid px-0">

                <div class="mb-6">
                    <BotonesNavegacion
                        @cambio-plataforma="plataformaActual = $event"
                    />
                </div>

                <header class="header-container mb-4">
                    <div class="section-title-bar mb-3">
                        <h2>Panel de Configuraciones</h2>
                    </div>
                    <p class="section-desc">
                        Para visualizar las configuraciones registradas en el sistema, acceda al menú y haga
                        clic sobre la opción <strong>Configuraciones</strong>.
                    </p>
                </header>

                <div class="two-col">
                    <div class="col-steps">
                        <p class="steps-label">Campos de configuración</p>

                        <div class="step-card">
                            <div class="step-badge">1</div>
                            <div class="step-desc">
                                <strong>IP del servidor:</strong> Dirección IP pública para que los dispositivos envíen las posiciones al servidor del proyecto.
                            </div>
                        </div>

                        <div class="step-card">
                            <div class="step-badge">2</div>
                            <div class="step-desc">
                                <strong>Número telefónico del arduino:</strong> Número que enviará y recibirá mensajes de texto a los dispositivos.
                            </div>
                        </div>

                        <div class="step-card">
                            <div class="step-badge">3</div>
                            <div class="step-desc">
                                <strong>Radio para almacenar posiciones estáticas (metros):</strong> Configuración para el registro de posiciones cuando estas superan determinada distancia.
                            </div>
                        </div>

                        <div class="step-card">
                            <div class="step-badge">4</div>
                            <div class="step-desc">
                                <strong>Puerto del servidor COBAN:</strong> Puerto para que los dispositivos COBAN envíen las posiciones al servidor.
                            </div>
                        </div>

                        <div class="step-card">
                            <div class="step-badge">5</div>
                            <div class="step-desc">
                                <strong>Puerto del servidor TKSTAR:</strong> Puerto para que los dispositivos TKSTAR envíen las posiciones al servidor.
                            </div>
                        </div>

                        <div class="step-card">
                            <div class="step-badge">6</div>
                            <div class="step-desc">
                                <strong>Compañía telefónica (APN):</strong> Punto de acceso para redes 3G y 4G que debe configurarse.
                            </div>
                        </div>

                        <div class="step-card">
                            <div class="step-badge">7</div>
                            <div class="step-desc">
                                <strong>Intervalo de alertas:</strong> Tiempo en segundos para la actualización de las alertas.
                            </div>
                        </div>

                        <div class="step-card">
                            <div class="step-badge">8</div>
                            <div class="step-desc">
                                <strong>Intervalo de dispositivos:</strong> Tiempo en segundos para la actualización de los dispositivos.
                            </div>
                        </div>

                        <div class="step-card">
                            <div class="step-badge">9</div>
                            <div class="step-desc">
                                <strong>Selección del país:</strong> Menú desplegable para establecer la región.
                            </div>
                        </div>

                        <div class="step-card">
                            <div class="step-badge">10</div>
                            <div class="step-desc">
                                <strong>Botón Guardar:</strong> Presionar para actualizar y aplicar las configuraciones en el sistema.
                            </div>
                        </div>
                    </div>

                    <div class="col-image">
                        <div class="carrusel-wrapper-box p-2">

                            <transition name="fade" mode="out-in">
                                <CarruselAciqui
                                    :key="plataformaActual"
                                    :items="itemsConfiguracion"
                                />
                            </transition>

                        </div>
                    </div>
                </div>

                <div class="doc-note note-warning mt-4">
                    <svg class="note-icon" width="15" height="15" viewBox="0 0 16 16" fill="none">
                        <path d="M8 2L14.9 14H1.1L8 2Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                        <circle cx="8" cy="11.5" r="0.75" fill="currentColor"/>
                    </svg>
                    <div class="note-body">
                        <span class="note-label">Nota</span>
                        <p>Solo el usuario <strong>master</strong> podrá visualizar esta vista.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';

import CarruselAciqui from './Carruselimg.vue';
import BotonesNavegacion from './BotonesNavegacion.vue';

/* WEB */
import configuracionWeb1 from '../../../../../public/img/configuraciones/Configuraciones.png';

const plataformaActual = ref('web');

const webData = [
    {
        nombre: "Interfaz de Configuraciones",
        url: configuracionWeb1,
        descripcion: "Referencia visual de los campos de configuración."
    }
];
const mobileData = [
    {
        nombre: "Interfaz de Configuraciones",
        url: "img/configuraciones/Configuraciones_Movil.png",
        descripcion: "Referencia visual de los campos de configuración."
    },
    {
        nombre: "Interfaz de Configuraciones",
        url: "img/configuraciones/Configuraciones_Movil_2.png",
        descripcion: "Referencia visual de los campos de configuración."
    },
    {
        nombre: "Interfaz de Configuraciones",
        url: "img/configuraciones/Configuraciones_Movil_3.png",
        descripcion: "Referencia visual de los campos de configuración."
    }
];

const itemsConfiguracion = computed(() => {
    return plataformaActual.value === 'web'
        ? webData
        : mobileData;
});
</script>

<style scoped>
/* ── Layout ───────────────────────────────────────── */
.two-col { display: flex; gap: 30px; align-items: flex-start; }
.col-steps { flex: 1; }
.col-image { flex: 1.2; position: sticky; top: 20px; }

/* ── Títulos ──────────────────────────────────────── */
.section-title-bar h2 { font-size: 20px; font-weight: 700; color: var(--primary-color); margin: 0; }
.steps-label { font-size: 11px; font-weight: 700; text-transform: uppercase; color: var(--primary-color); letter-spacing: 1px; margin-bottom: 15px; }
.section-desc { font-size: 14.5px; color: var(--text-color); opacity: 0.85; line-height: 1.6; }

/* ── Step Cards ──────────────────────────────────── */
.step-card {
    display: flex; gap: 15px; align-items: center;
    background: var(--code-bg); border: 1px solid var(--border-color);
    border-radius: 8px; padding: 12px 15px; margin-bottom: 8px;
    transition: transform 0.2s ease;
}
.step-card:hover { transform: translateX(5px); border-color: var(--primary-color); }

.step-badge {
    min-width: 26px; height: 26px; border-radius: 50%;
    background: var(--primary-color); color: #fff;
    font-size: 11px; font-weight: 700;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.step-desc { font-size: 13.5px; color: var(--text-color); line-height: 1.5; margin: 0; }
.step-desc strong { color: var(--primary-color); }

/* ── Carrusel Box ────────────────────────────────── */
.carrusel-wrapper-box { background: var(--code-bg); border-radius: 12px; border: 1px solid var(--border-color); box-shadow: 0 4px 12px rgba(0,0,0,0.05); }

.mb-6 {
    margin-bottom: 2rem;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* ── Notas ────────────────────────────────────────── */
.doc-note { display: flex; gap: 12px; padding: 15px; border-radius: 8px; border: 1px solid; font-size: 14px; }
.note-warning { background: #fffbeb; border-color: #d97706; color: #d97706; }
.note-label { font-weight: 700; text-transform: uppercase; font-size: 10px; display: block; margin-bottom: 2px; }

@media (max-width: 991px) {
    .two-col { flex-direction: column; }
    .col-image { width: 100%; position: static; }
}
</style>